import { parseDate } from './utils'

export default class Transport {
	static fromJson(json) {
		if (!json) return null

		return new Transport(json.requisitionId)
			.withRequisitionId(json)
			.withOriginalRequisitionId(json)
			.withTransportType(json)
			.withTransportDateTime(json)
			.withRefusedState(json)
	}

	constructor(id) {
		this.requisitionId = id
	}

	withRequisitionId(json) {
		this.requisitionId = json.requisitionId
		return this
	}

	withOriginalRequisitionId(json) {
		this.originalRequisitionId = json.originalRequisitionId
		return this
	}

	withTransportType(json) {
		this.transportType = json.transportType
		return this
	}

	withTransportDateTime(json) {
		this.transportDateTime = json.transportDateTime
			? parseDate(json.transportDateTime)
			: null
		return this
	}

	withRefusedState(json) {
		this.refused = json.refused
		return this
	}
}
